<template>
  <div>
    <GrbData></GrbData>
  </div>
</template>

<script>
import GrbData from '../components/GrbData.vue';

export default {
  components: {
    GrbData,
  },
};
</script>